<template>
  <div class="setting">

<el-breadcrumb separator="/">
  <el-breadcrumb-item :to="{ name: 'allDomain' }">{{$t('allDomain.DomainNames')}}</el-breadcrumb-item>
  <el-breadcrumb-item :to="{ name: 'subdomains', params: { id: id } }">{{ subhost }}</el-breadcrumb-item>
  <el-breadcrumb-item>{{ host }} | {{this.$t('allDomain.cert')}} </el-breadcrumb-item>
</el-breadcrumb>

    <!--  -->
    <div class="tab-content">
   <el-tabs v-model="activeName" @tab-click="handleClick">       
    <el-tab-pane lazy :label="$t('allDomain.cert')" name="list">
      <SubdomainCertList :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane>
    <el-tab-pane lazy :label="$t('allDomain.applyCert')" name="cert">
      <SubdomainCert :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane>
  </el-tabs>
    </div>
  </div>
</template>

<script>
import { apiGetDetail } from "@/service/requestRes";

import SubdomainCert from '@/views/domain/SubdomainCert.vue';
import SubdomainCertList from '@/views/domain/SubdomainCertList.vue';


export default {
  components: {
    SubdomainCert,
    SubdomainCertList,
  },
  props: {
    rootDomain: String,
  },
  data() {
    return {
      id: this.$route.params.id,
      sid: this.$route.params.sid,
      activeName: 'list',
      detail: null,
      subhost: null,
      host: null,
      domainHost: null,
      host_json_server: '',
    };
  },
  mounted(){
    this.getDetail();
  },
  computed: {
    items() {
      return [
        {
          label: this.$t('allDomain.DomainNames'),
          click: () => {
            this.$emit('closePage');
          },
        },
        {
          label: this.$t('allDomain.config'),
        },
      ];
    },
  },
  methods: {
    getDetail() {
      apiGetDetail(
          'host', this.sid
      ).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
            this.subhost = data.sub_host;
            this.host = data.host;
            this.domainHost = data.host;
            this.host_json_server = data.host_json_server || '';
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    handleClick(tab, event) {
    //   console.log(tab, event);
    },
  },
};
</script>
<style lang="scss" scoped>
  .setting {
    background-color: white;
    padding: 24px;
  }
  .tab-content {
    margin-top: 24px;
    ::v-deep .el-tabs__item.is-active {
       color: #2664FF;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #2664FF;
    }
  }
</style>
